import React from 'react';
import { connect } from 'react-redux';

import { Section } from 'jbc-front/components/Form';
import { getOptionLabel, display } from 'src/utils/Utils';
import { formatDate } from 'src/utils/Date';
import { getRadioOptions, getSelectOptions } from 'src/reducers/selectOptions';
import { Checked } from 'src/icons';
import tableStyles from '../styles/GeneralTableInfo.scss';
import { useTranslation } from 'react-i18next';

const GeneralInsuranceInfoSection = ({ employeeInsurance, insuredPersonTypes }) => {
  const { t } = useTranslation();
  return(
    <div>
      <Section title={t('features.Employees.components.SocialInsurance.insured_person_type.title')}>
        <table className={tableStyles.mTablePersonal}>
          <tbody>
            <tr>
              <th>{t('features.Employees.components.SocialInsurance.insured_person_type.component.insured_person_type')}：</th>
              <td>{display(getOptionLabel(employeeInsurance.insuredPersonType)(insuredPersonTypes))}</td>
            </tr>
          </tbody>
        </table>
      </Section>
    </div>
  )
};

const GeneralInsuranceInfoSectionShow = connect(state => ({
  insuredPersonTypes: getSelectOptions(state, 'insuredPersonTypes')
}))(GeneralInsuranceInfoSection);

// Changing to SSO
// const HealthInsuranceSectionShow = ({ employeeInsurance }) => (
//   <div>
//     <Section title="健康保険">
//       <table className={tableStyles.mTablePersonal}>
//         <tbody>
//           <tr>
//             <th>加入状況：</th>
//             <td>{display(employeeInsurance.isJoinedHealthInsurance ? '加入' : '未加入')}</td>
//           </tr>
//           <tr>
//             <th>健康保険被保険者整理番号：</th>
//             <td>{display(employeeInsurance.healthInsuranceInsuredPersonnelNumber)}</td>
//           </tr>
//           <tr>
//             <th>資格取得日：</th>
//             <td>{display(formatDate(employeeInsurance.healthCertificateAcquisitionOn))}</td>
//           </tr>
//           <tr>
//             <th>資格喪失日：</th>
//             <td>{display(formatDate(employeeInsurance.healthCertificateExpiredOn))}</td>
//           </tr>
//         </tbody>
//       </table>
//     </Section>
//   </div>
// );

// const PensionInsuranceSectionShow = ({ employeeInsurance, hasTargetHealthInsuranceAssociations }) => (
//   <div>
//     <Section title="厚生年金保険">
//       <table className={tableStyles.mTablePersonal}>
//         <tbody>
//           <tr>
//             <th>加入状況：</th>
//             <td>{display(employeeInsurance.isJoinedPensionInsurance ? '加入' : '未加入')}</td>
//           </tr>
//           <tr>
//             <th>基礎年金番号：</th>
//             <td>{display(employeeInsurance.pensionBasicNumber)}</td>
//           </tr>
//           {hasTargetHealthInsuranceAssociations && (
//             <tr>
//               <th>{t('features.Employees.components.SocialInsurance.health_insurance.component.is_joined_health_insurance')}：</th>
//               <td>{display(employeeInsurance.isJoinedHealthInsurance ? t('features.Employees.components.SocialInsurance.health_insurance.options.yes') : t('features.Employees.components.SocialInsurance.health_insurance.options.no'))}</td>
//             </tr>
//           )}
//           <tr>
//             <th>{t('features.Employees.components.SocialInsurance.health_insurance.component.health_insurance_insured_personnel_number')}：</th>
//             <td>{display(employeeInsurance.healthInsuranceInsuredPersonnelNumber)}</td>
//           </tr>
//           <tr>
//             <th>{t('features.Employees.components.SocialInsurance.health_insurance.component.health_certificate_acquisition_on')}：</th>
//             <td>{display(formatDate(employeeInsurance.healthCertificateAcquisitionOn))}</td>
//           </tr>
//           <tr>
//             <th>{t('features.Employees.components.SocialInsurance.health_insurance.component.health_certificate_expired_on')}：</th>
//             <td>{display(formatDate(employeeInsurance.healthCertificateExpiredOn))}</td>
//           </tr>
//         </tbody>
//       </table>
//     </Section>
//   </div>
// );


const PensionInsuranceSectionShow = ({ employeeInsurance, hasTargetHealthInsuranceAssociations }) => {
  const { t } = useTranslation();
  return(
    <div>
      <Section title={t('features.Employees.components.SocialInsurance.pension_insurance.title')}>
        <table className={tableStyles.mTablePersonal}>
          <tbody>
            <tr>
              <th>{t('features.Employees.components.SocialInsurance.pension_insurance.component.is_joined_pension_insurance')}：</th>
              <td>{display(employeeInsurance.isJoinedPensionInsurance ? t('features.Employees.components.SocialInsurance.pension_insurance.options.yes') : t('features.Employees.components.SocialInsurance.pension_insurance.options.no'))}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.SocialInsurance.pension_insurance.component.pension_basic_number')}：</th>
              <td>{display(employeeInsurance.pensionBasicNumber)}</td>
            </tr>
            {hasTargetHealthInsuranceAssociations && (
              <tr>
                <th>{t('features.Employees.components.SocialInsurance.pension_insurance.component.pension_insurance_insured_number')}：</th>
                <td>{display(employeeInsurance.pensionInsuranceInsuredNumber)}</td>
              </tr>
            )}
            <tr>
              <th>{t('features.Employees.components.SocialInsurance.pension_insurance.component.pension_certificate_acquisition_on')}：</th>
              <td>{display(formatDate(employeeInsurance.pensionCertificateAcquisitionOn))}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.SocialInsurance.pension_insurance.component.pension_certificate_expired_on')}：</th>
              <td>{display(formatDate(employeeInsurance.pensionCertificateExpiredOn))}</td>
            </tr>
          </tbody>
        </table>
      </Section>
    </div>
)
};

const EmploymentInsuranceSectionShow = ({ employeeInsurance }) => {
  const { t } = useTranslation();
  return(
    <div>
      <Section title={t('features.Employees.components.SocialInsurance.employment_insurance.title')}>
        <table className={tableStyles.mTablePersonal}>
          <tbody>
            <tr>
              <th>{t('features.Employees.components.SocialInsurance.employment_insurance.component.is_joined_employment_insurance')}：</th>
              <td>{display(employeeInsurance.isJoinedEmploymentInsurance ? t('features.Employees.components.SocialInsurance.employment_insurance.options.yes') : t('features.Employees.components.SocialInsurance.employment_insurance.options.no'))}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.SocialInsurance.employment_insurance.component.employment_insurance_insured_number')}：</th>
              <td>{display(employeeInsurance.employmentInsuranceInsuredNumber)}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.SocialInsurance.employment_insurance.component.employment_certificate_acquisition_on')}：</th>
              <td>{display(formatDate(employeeInsurance.employmentCertificateAcquisitionOn))}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.SocialInsurance.employment_insurance.component.employment_certificate_expired_on')}：</th>
              <td>{display(formatDate(employeeInsurance.employmentCertificateExpiredOn))}</td>
            </tr>
            {employeeInsurance.isJoinedEmploymentInsurance &&
              employeeInsurance.isTargetAgedEmployee && (
                <tr>
                  <th>{t('features.Employees.components.SocialInsurance.employment_insurance.component.is_aged_employee')}：</th>
                  <td>
                    <Checked checked={employeeInsurance.isAgedEmployee} />
                  </td>
                </tr>
              )}
          </tbody>
        </table>
      </Section>
    </div>
  )
};
// let AccidentInsuranceSectionShow = ({ employeeInsurance, employeeClassifications }) => (
//   <div>
//     <Section title="労災保険">
//       <table className={tableStyles.mTablePersonal}>
//         <tbody>
//           <tr>
//             <th>従業員区分：</th>
//             <td>{display(getOptionLabel(employeeInsurance.employeeClassification)(employeeClassifications))}</td>
//           </tr>
//         </tbody>
//       </table>
//     </Section>
//   </div>
// );

// AccidentInsuranceSectionShow = connect(state => ({
//   employeeClassifications: getRadioOptions(state, 'employeeClassifications')
// }))(AccidentInsuranceSectionShow);

const InsuranceSectionShow = ({ employeeInsurance, hasTargetHealthInsuranceAssociations }) => (
  <div>
    <GeneralInsuranceInfoSectionShow {...{ employeeInsurance }} />
    {/* <HealthInsuranceSectionShow {...{ employeeInsurance }} /> */}
    <PensionInsuranceSectionShow {...{ employeeInsurance, hasTargetHealthInsuranceAssociations }} />
    {/* <EmploymentInsuranceSectionShow {...{ employeeInsurance }} /> */}
    {/* <AccidentInsuranceSectionShow {...{ employeeInsurance }} /> */}
  </div>
);

export default InsuranceSectionShow;
